import { jsx as _jsx } from "react/jsx-runtime";
function Layout({ children }) {
    return _jsx("div", { className: "flex-finalize-layout", children: children });
}
export default Layout;
